import { useMutation } from '@tanstack/react-query';

import {
  PluginTangoRequest,
  PluginTangoResponse,
} from '../../../../types/plugins';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { runTangoRequest } from '../../requests/runTangoRequest';

export const useRunTangoRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation<
    PluginTangoResponse | undefined,
    Error,
    PluginTangoRequest
  >({
    mutationFn: (data) =>
      runTangoRequest(constructPost, data).then((r) => r?.data),
    onError: (error: ApiErrorResponse) =>
      handleError(
        getApiErrorMessage(error, 'Could not load Tango XML for application.'),
      ),
  });
  return { runTangoRequest: mutateAsync, ...rest };
};
